import React, {useCallback} from "react";
import {MenuPicker} from "./MenuPicker";
import {DecisionDialog} from "../../dialog-windows/DecisionDialog";
import {setSchedulerActive} from "../../../../../slices/cmsSlice";
import {setCmsActive, setCurrentView} from "../../../../../slices/globalParamsSlice";
import {STATS} from "../../../../../utils/viewsConstants";
import {setEditRestaurantFormActive} from "../../../../../slices/restaurantSlice";
import {generateUUID} from "../../../../../utils/utils";
import {useTranslation} from "react-i18next";
import {useDispatch} from "react-redux";

export const SchedulerDialogs = ({
                                     syncMenusWithCalendar,
                                     selectedMenu,
                                     setSelectedMenu,
                                     menuOptions,
                                     dialogRef,
                                     openingHoursDialogOpen,
                                     setOpeningHoursDialogOpen,
                                     pendingSelection,
                                     setPendingSelection,
                                     menuPickerOpen,
                                     setMenuPickerOpen
                                 }) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const closeMenuPicker = useCallback(() => {
        setMenuPickerOpen(false);
        setPendingSelection(null);
    }, []);

    const addMenu = useCallback((selectedMenu) => {
        if (!pendingSelection || !selectedMenu) return;

        const calendarApi = pendingSelection.view.calendar;
        const id = generateUUID();
        const menu = selectedMenu.value;

        calendarApi.addEvent({
            id,
            title: menu?.name || menu?.title || "Menu",
            start: pendingSelection.start,
            end: pendingSelection.end,
            extendedProps: {
                menuId: menu.id,
                isStandard: !!menu.standard,
                color: menu.color
            },
        });

        calendarApi.unselect();
        syncMenusWithCalendar(calendarApi);
        closeMenuPicker();
    }, [pendingSelection, selectedMenu, syncMenusWithCalendar, closeMenuPicker]);

    if (menuPickerOpen) {
        return (
            <MenuPicker closeMenuPicker={closeMenuPicker}
                        addMenu={addMenu}
                        menuOptions={menuOptions}
                        setSelectedMenu={setSelectedMenu}
                        dialogRef={dialogRef}/>
        );
    }

    if (openingHoursDialogOpen) {
        return (
            <DecisionDialog
                msg={t('goToOperatingHours')}
                onSubmit={() => {
                    dispatch(setSchedulerActive(false));
                    dispatch(setCmsActive(false));
                    dispatch(setCurrentView(STATS));
                    dispatch(setEditRestaurantFormActive(true));
                }}
                onCancel={() => setOpeningHoursDialogOpen(false)}
            />
        );
    }

    return null;
}